import React from "react";
import { Box, Divider, Link, Typography } from "@mui/material";
import { baseColors } from "../theme";
import { getExternalUrls } from "../configuration/config-external-urls";

const GdprCookies = () => {
	const currentYear = new Date().getFullYear();

	return (
		<Box display="flex" flexDirection="column" mb={3} alignItems="center">
			<Typography align="center" variant="body2" sx={{ color: baseColors.textSecondary }}>
				Údaje využijeme pouze pro odeslání požadovaných informací.
			</Typography>

			<Box display="flex" marginTop={1} alignItems="center">
				<Typography variant="caption" sx={{ color: baseColors.textSecondary }}>
					Copyright {currentYear} ČEZ Distribuce, a. s.
				</Typography>
				<Divider sx={{ marginLeft: "0.4rem", marginRight: "0.4rem" }} orientation="vertical" flexItem></Divider>
				<Typography variant="caption" sx={{ color: baseColors.textSecondary }}>
					Všechna práva vyhrazena
				</Typography>
			</Box>

			<Box display="flex" alignItems="center">
				<Link
					variant="caption"
					color={baseColors.textSecondary}
					underline="always"
					tabIndex={-1}
					href={getExternalUrls().GDPR_PAGE_URL}
					target="_blank"
				>
					Ochrana osobních údajů (GDPR)
				</Link>
			</Box>
		</Box>
	);
};

export default GdprCookies;
